module.exports = __webpack_public_path__ + "static/media/snake.e981bd6b.jpg";